const regex = /^[A-Z]{2}[0-9]{14}$/;
const getMessage = () => `自然人憑證條碼格式錯誤`;
const validate = (value) => regex.test(value);

/** 自訂驗證 自然人憑證條碼載具 格式 */
export default {
  getMessage,
  validate,
};
